module.exports = __webpack_public_path__ + "static/media/Hero_Image_Mobile.2aee8446.jpg";